var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('baseBreadcrumb',{attrs:{"page":_vm.$t('message.homePreview'),"menu":_vm.$t('message.operationAndMaintenance')}}),_c('div',{staticClass:"body"},[_c('staticBanner'),_c('recommend'),_c('classifyGoods')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }